<template lang="pug">
v-dialog(v-model="dialogAdd" width="700" persistent)
    template(v-slot:activator="{ on, attrs }")
        v-btn.ml-2(v-if="!itemIsNull" small color="blue" dark v-bind="attrs" v-on="on")
            v-icon(small) mdi-square-edit-outline
        v-btn.ml-10(v-else small color="green" dark v-bind="attrs" v-on="on")
            v-icon(small) mdi-plus-circle
            | &nbsp; Add New Survey Template

    v-card
        v-card-title {{ itemIsNull ? 'Add New' : 'Update' }} Survey
        v-card-text
            v-text-field(label="Survey Template Name" v-model="form.name" :disable="dialogAddLoading")
            
            v-data-table(
                    v-if="!itemIsNull"
                    :headers="headers"
                    :items="form.data"
                    sort-by="sort"
                    :sort-desc="false"
                    hide-default-footer
                    show-expand
                )

                template(v-slot:item.questions="{ item }")
                    div {{ item.TranslatedQuestion.DisplayNameTranslation }}


                template(v-slot:expanded-item="{ headers, item }")
                    td(:colspan="headers.length")
                        v-row
                            v-col(align="end")
                                v-btn(icon color="blue" :disabled="findIndex(item) == 0" dark @click="moveUp(item)")
                                    v-icon(small) mdi-arrow-up-drop-circle-outline
                                v-btn(icon color="blue" :disabled="itemIsLast(item)" dark @click="moveDown(item)")
                                    v-icon(small) mdi-arrow-down-drop-circle-outline
                                v-btn(icon color="red" dark @click="deleteItem(item)")
                                    v-icon(small) mdi-delete

        v-divider
        v-card-actions
            v-spacer
            v-btn(v-if="!dialogAddLoading" small color="red" text @click="dialogAdd = false") Cancel
            v-btn(small color="primary" text @click="addTemplate" :loading="dialogAddLoading") Submit

</template>

<script>
import { mapActions } from 'vuex';
import Config from '../../../../configuration';

export default {
    props: {
        item: {
            type: Object,
            default() {
                return {
                    name: null,
                    data: '[]',
                    active: false
                };
            }
        },
        items: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            dialogAdd: false,
            dialogAddLoading: false,
            imageForm: null,
            form: {
                name: this.item.name,
                data: this.getLists(this.item.data),
                active: this.item.active
            },
            successMessage: false,
            error: {
                show: false,
                message: ''
            },
            headers: [
                {
                    text: 'Questions',
                    align: 'start',
                    sortable: false,
                    value: 'questions',
                },
                {
                    text: '',
                    align: 'end',
                    value: 'data-table-expand'
                }
            ],
        };
    },
    computed: {
        itemIsNull() {
            return !this.item || !this.item.name && !this.item.description;
        },
    },
    methods: {
        findIndex(item) {
            return this.form.data.indexOf(item);
        },
        itemIsLast(item) {
            return (this.form.data.length - 1) == this.findIndex(item);
        },
        moveUp(item) {
            const currentIndex = this.form.data.indexOf(item);
            this.moveArrayValue(this.form.data, currentIndex, currentIndex-1);
            this.updateSorting();
        },
        moveDown(item) {
            const currentIndex = this.form.data.indexOf(item);
            this.moveArrayValue(this.form.data, currentIndex, currentIndex+1);
            this.updateSorting();
        },
        updateSorting() {
            this.form.data = this.form.data.map((i, index) => {
                i.sort = index;
                return i;
            });
        },
        moveArrayValue(input, from, to) {
            let numberOfDeletedElm = 1;
            const elm = input.splice(from, numberOfDeletedElm)[0];
            numberOfDeletedElm = 0;
            input.splice(to, numberOfDeletedElm, elm);
        },
        deleteItem(item) {
            const currentIndex = this.form.data.indexOf(item);
            this.form.data.splice(currentIndex, 1);
            this.updateSorting();
        },
        async addTemplate() {
            this.dialogAddLoading = true;
            try {
                if(this.itemIsNull) {
                    await this.createSurveyTemplate({
                        ...this.form
                    });
                    this.form.name = null;
                    this.form.data = '[]';
                    this.form.active = false;
                    this.$emit('success');
                    this.dialogAdd = false;
                } else {
                    this.item.name = this.form.name;
                    this.item.data = JSON.stringify(this.form.data.map(i => ({id: i.id, value: i.value, sort: i.sort})));
                    this.item.active = this.form.active;
                    const result = await this.item.patch();
                    this.$emit('success');
                    this.dialogAdd = false;
                }
            } catch(err) {
                this.$emit('error', err)
            } finally {
                this.dialogAddLoading = false;
            }
        },
        getLists(data) {
            const $d = JSON.parse(data);
            const json = $d.reduce((ret, item) => {
                ret.push(item.id);
                return ret;
            }, []);
            const result = this.items.filter(i => json.includes(i.id));
            const idObj = $d.reduce((ret, item) => {
                ret[item.id] = item.value;
                return ret;
            }, {});
            return result.map(i => {
                i.value = idObj[i.id];
                return i;
            });
        },
        ...mapActions('bh-toluna-templates', { createSurveyTemplate: 'create' })
    }
}
</script>